/**
 * ChargeListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  TabMenu,
  Information,
} from 'components';
import { Input, Button, Avatar, Radio } from 'antd';

const ChargeListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedItem, setSelectedItem] = useState(null);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form = [
    {
      label: '구분',
      form: [
        {
          input: (
            <>
              <p>{'전체카테고리 > 커피/원두 > 전체상품'}</p>
            </>
          ),
        },
      ],
    },
    {
      label: '구분',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'비율'}>
                <Radio value={'비율'}>비율</Radio>
                <Radio value={'금액'}>금액</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '수수료',
      form: [
        {
          input: (
            <>
              <Input
                style={{ ...styles.form.input.medium, width: 67 }}
                placeholder="0.0"
              />
              <p>%</p>
            </>
          ),
        },
      ],
    },
  ];

  let tabItems = [];
  for (let i = 0; i < 9; i++) {
    tabItems.push({
      key: `${i}`,
      label: i === 0 ? '전체' : `커피점 ${i}`,
      children: [
        {
          key: `${i}_커피`,
          label: '커피/원두',
        },
        {
          key: `${i}_티`,
          label: '티/액상차/티웨어',
        },
        {
          key: `${i}_시럽`,
          label: '시럽/소스',
        },
        {
          key: `${i}_음료`,
          label: '음료/탄산수',
        },
      ],
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>수수료 관리</Title>

          <Row style={{ minHeight: '80vh' }}>
            {/* 업체목록 */}
            <Col
              x={4}
              style={{
                borderRight: '1px solid #EBEBEB',
                background: '#FFFFFF',
              }}
            >
              <Content
                maxWidth={'100%'}
                padding={5}
                style={{ borderBottom: '1px solid #EBEBEB' }}
              >
                <Input placeholder="업체명을 입력해주세요" />
              </Content>

              <Content maxWidth={'100%'} padding={0}>
                <TabMenu items={tabItems} />
              </Content>
            </Col>
            {/* 업체목록 끝 */}

            {/* 상품목록 */}
            <Col
              x={5}
              style={{
                borderRight: '1px solid #EBEBEB',
                background: '#EFEFEF',
              }}
            >
              <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((_item, _index) => (
                  <div
                    key={`product_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: 8,
                      cursor: 'pointer',
                      border:
                        selectedItem === _item
                          ? '1px solid #2394E4'
                          : '1px solid #EFEFEF',
                      borderBottom:
                        selectedItem === _item
                          ? '1px solid #2394E4'
                          : '1px solid #DFDFDF',
                      background:
                        selectedItem === _item
                          ? 'rgba(28, 107, 244, 0.3)'
                          : '#EFEFEF',
                    }}
                    onClick={() => setSelectedItem(_item)}
                  >
                    <div>
                      <Avatar shape="square" size={30} />
                    </div>
                    <div style={{ paddingLeft: 7 }}>
                      <h4>
                        {_index === 0
                          ? '선택안함(전체적용)'
                          : '[과테말라] 디카페인 200g'}
                      </h4>
                      {_index !== 0 && <p>20,000원</p>}
                    </div>
                  </div>
                ))}
              </Content>
            </Col>
            {/* 상품목록 끝 */}

            {/* 수수료 설정 */}
            <Col
              x={15}
              style={{
                background: '#FFFFFF',
              }}
            >
              <Content maxWidth={'100%'} padding={0}>
                <div style={{ borderBottom: '1px solid #EBEBEB', padding: 10 }}>
                  <h2
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: '#404040',
                      lineHeight: '133%',
                    }}
                  >
                    수수료 설정
                  </h2>
                </div>
                <Content maxWidth={'100%'} padding={10}>
                  <Information
                    content={[
                      '오늘 입금될 상품 결제대금과 과거 정산내역, 상품주문별 상세 정산내역을 확인하실 수 있습니다.',
                      '상품주문별 결제대금 및 수수료와 관련된 결제대금 정산, 할인/적립과 관련된 혜택정산, 상품 판매대금에 연계되지 못하고 적용되는 일별/공제 환급, 지급보류 금액을 확인하실 수 있습니다.',
                      '스마트스토어 판매 내역의 부가세신고를 돕기 위한 참고 자료를 확인하실 수 있습니다.',
                      '수수료내역(네이버페이 결제수수료, 네이버쇼핑 매출연동수수료, 무이자할부수수료,(구)판매수수료 등)에 대해 판매자에게 발행된 세금계산서 내역을 확인하실 수 있습니다.',
                    ]}
                  />
                </Content>

                <Content maxWidth={'100%'} padding={10}>
                  <InputFormTable form={form} />
                </Content>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 10,
                  }}
                >
                  <Button
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                      color: '#FFFFFF',
                    }}
                  >
                    저장
                  </Button>
                  <Button style={{ ...styles.button }}>초기화</Button>
                </div>
              </Content>
            </Col>
            {/* 수수료 설정 끝 */}
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default ChargeListPresenter;
